/* ==========================================================================
   Helsam — Videns-artikel: indholdsfortegnelse og del-knap

   Det lidt JS templaten har brug for. Alt andet virker uden:
   indholdsfortegnelsen er links, AI-formularen håndteres af ai-chatbot.js, og
   produktkortene poster til /cart/add hvis product-form.js ikke er der.

   Del-knappen kræver JS — der findes ingen HTML-only måde at kopiere til
   udklipsholderen. Dropdownen starter derfor skjult med `hidden` og åbnes
   først herfra, så den ikke står som en død menu hvis JS fejler.

   §4.2: aktivt punkt sættes af IntersectionObserver, og "ingen aktiv" er en
   gyldig tilstand — derfor sættes aria-current kun når noget faktisk er synligt.
   ========================================================================== */

(function () {
  'use strict';

  function initToc(root) {
    var toc = root.querySelector('[data-kn-toc]');
    if (!toc || toc.dataset.knReady) return;
    if (!('IntersectionObserver' in window)) return;
    toc.dataset.knReady = 'true';

    var links = Array.prototype.slice.call(toc.querySelectorAll('.kn-toc__link'));
    var targets = links
      .map(function (link) {
        var id = (link.getAttribute('href') || '').slice(1);
        var el = id ? document.getElementById(id) : null;
        return el ? { link: link, el: el } : null;
      })
      .filter(Boolean);

    if (!targets.length) return;

    var visible = [];

    function paint() {
      // Det øverste synlige afsnit er det aktive.
      var active = null;
      for (var i = 0; i < targets.length; i++) {
        if (visible.indexOf(targets[i].el) === -1) continue;
        if (!active || targets[i].el.offsetTop < active.el.offsetTop) active = targets[i];
      }
      links.forEach(function (link) {
        if (active && link === active.link) {
          link.setAttribute('aria-current', 'true');
        } else {
          link.removeAttribute('aria-current');
        }
      });
    }

    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          var at = visible.indexOf(entry.target);
          if (entry.isIntersecting && at === -1) {
            visible.push(entry.target);
          } else if (!entry.isIntersecting && at > -1) {
            visible.splice(at, 1);
          }
        });
        paint();
      },
      { rootMargin: '-88px 0px -60% 0px' }
    );

    targets.forEach(function (t) {
      observer.observe(t.el);
    });
  }

  /* ---------------------------------------------------------------------- *
   * Del artikel
   *
   * Samme adfaerd som favoritsiden (assets/wishlist.js): paa mobil med
   * navigator.share aabnes den native delemenu; ellers en dropdown med
   * kopier-link, e-mail og Messenger.
   *
   * Tre bevidste forskelle fra wishlist.js:
   *   1. Delelinket er artiklens egen URL (origin + pathname) uden
   *      query-parametre, saa sporingsparametre ikke deles videre.
   *   2. Lytterne bindes pr. element via data-attributter frem for ID'er, saa
   *      sektionen taaler at blive genindlaest i temaeditoren.
   *   3. Escape lukker dropdownen, og fokus foeres tilbage til knappen.
   * ---------------------------------------------------------------------- */
  function initShare(root) {
    var wrap = root.querySelector('[data-kn-share]');
    if (!wrap || wrap.dataset.knShareReady) return;
    wrap.dataset.knShareReady = 'true';

    var trigger = wrap.querySelector('[data-kn-share-trigger]');
    var dropdown = wrap.querySelector('[data-kn-share-dropdown]');
    if (!trigger || !dropdown) return;

    var title = wrap.getAttribute('data-kn-share-title') || document.title;
    var url = window.location.origin + window.location.pathname;

    function close() {
      trigger.setAttribute('aria-expanded', 'false');
      dropdown.hidden = true;
    }

    function open() {
      var email = wrap.querySelector('[data-kn-share-email]');
      if (email) {
        email.href =
          'mailto:?subject=' + encodeURIComponent(title) +
          '&body=' + encodeURIComponent(title + '\n\n' + url);
      }

      var messenger = wrap.querySelector('[data-kn-share-messenger]');
      if (messenger) {
        // Messenger har ingen delelink paa desktop; der aabnes web-klienten,
        // praecis som paa favoritsiden.
        var isMobile = /Android|iPhone|iPad|iPod/i.test(navigator.userAgent);
        messenger.href = isMobile
          ? 'fb-messenger://share?link=' + encodeURIComponent(url)
          : 'https://www.messenger.com/';
        if (!isMobile) messenger.title = 'Aabn Messenger og del linket manuelt';
      }

      trigger.setAttribute('aria-expanded', 'true');
      dropdown.hidden = false;
    }

    trigger.addEventListener('click', function (event) {
      event.stopPropagation();

      if (navigator.share && window.matchMedia('(max-width: 768px)').matches) {
        navigator.share({ title: title, url: url }).catch(function () {});
        return;
      }

      if (trigger.getAttribute('aria-expanded') === 'true') {
        close();
      } else {
        open();
      }
    });

    // Klik ved siden af lukker. Klik INDE i dropdownen maa ikke boble op hertil.
    dropdown.addEventListener('click', function (event) {
      event.stopPropagation();
    });
    document.addEventListener('click', close);

    document.addEventListener('keydown', function (event) {
      if (event.key !== 'Escape' || dropdown.hidden) return;
      close();
      trigger.focus();
    });

    var copy = wrap.querySelector('[data-kn-share-copy]');
    var label = copy && copy.querySelector('.kn-share__label');
    if (!copy) return;

    copy.addEventListener('click', function () {
      var original = label ? label.textContent : '';

      function confirmed() {
        copy.classList.add('kn-share__option--copied');
        if (label) label.textContent = 'Kopieret';
        setTimeout(function () {
          copy.classList.remove('kn-share__option--copied');
          if (label) label.textContent = original;
          close();
        }, 1800);
      }

      if (navigator.clipboard && navigator.clipboard.writeText) {
        navigator.clipboard.writeText(url).then(confirmed, fallback);
      } else {
        fallback();
      }

      // execCommand er forceldet, men er den eneste vej udenfor et sikkert
      // origin (og i aeldre Safari), hvor navigator.clipboard ikke findes.
      function fallback() {
        var field = document.createElement('textarea');
        field.value = url;
        field.setAttribute('readonly', 'readonly');
        field.style.position = 'fixed';
        field.style.top = '0';
        field.style.opacity = '0';
        document.body.appendChild(field);
        field.select();
        try {
          document.execCommand('copy');
          confirmed();
        } catch (err) {
          close();
        }
        document.body.removeChild(field);
      }
    });
  }

  function init(root) {
    initToc(root || document);
    initShare(root || document);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      init(document);
    });
  } else {
    init(document);
  }

  // Temaeditoren genindlæser sektionen uden at genindlæse siden.
  document.addEventListener('shopify:section:load', function (event) {
    init(event.target);
  });
})();
